import React from 'react';
import { TFunction } from 'react-i18next';
import { MUIDataTableColumnDef } from 'web-library';
import Typography from 'web-library/stories/atom/Typography/Typography';
import Box from 'web-library/stories/atom/Box/Box';
import { ViewSelectedSubjectPapers } from '../../api/candidate/exam/model';

const addComma = (index: number, length: number): string => (length - 1 !== index ? ', ' : '');

const renderOptionalPaper = (optionalPapers: ViewSelectedSubjectPapers[], t: TFunction<string>) =>
  optionalPapers.map((paper, index, { length }) => {
    if (paper.selected) {
      return `${t('exam->>ReviewExam.Paper')} ${paper.paperNo}${addComma(index, length)}`;
    }
    return '';
  });

const ReviewSubjectDataColumn = ({
  dataContent,
  t,
  classes,
  payment,
}: any): MUIDataTableColumnDef[] => {
  const gstPercentage = payment?.gstPercentage || '7';
  return [
    {
      name: 'subjectName',
      label: t('exam->>ReviewExam.Subject Name'),
      options: {
        filter: false,
        sort: false,
        searchable: false,
        customBodyRenderLite: (dataIndex: number) => (
          <Box className={classes.subject}>
            <Typography variant="body2" className={classes.subjectName}>
              {dataContent[dataIndex].subjectName}
              {'\u00A0'}({dataContent[dataIndex].subjectCode})
            </Typography>
            {dataContent[dataIndex].optionalPapers.length > 0 && (
              <Typography variant="body2" className={classes.optionalPaper}>
                + {t('exam->>ReviewExam.Optional Papers')}:{'\u00A0'}
                {renderOptionalPaper(dataContent[dataIndex].optionalPapers, t)}
              </Typography>
            )}
          </Box>
        ),
      },
    },
    {
      name: 'subjectLevel',
      label: t('exam->>ReviewExam.Subject Level'),
      options: {
        filter: false,
      },
    },
    {
      name: 'examSeries',
      label: t('exam->>ReviewExam.Exam Series'),
      options: {
        filter: false,
        sort: false,
        searchable: false,
      },
    },
    {
      name: 'examLevel',
      label: t('exam->>ReviewExam.Exam Level'),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex: number, rowIndex: number) => (
          <Typography id={`text-examLevel-row${rowIndex}`} variant="body2">
            {dataContent[dataIndex].examLevel || 'N/A'}
          </Typography>
        ),
      },
    },

    {
      name: 'language',
      label: t('exam->>ReviewExam.Language Medium'),
      options: {
        filter: false,
        sort: false,
        searchable: false,
      },
    },
    {
      name: 'fee',
      options: {
        filter: false,
        sort: false,
        searchable: false,
        customHeadLabelRender: () => (
          <Typography className={classes.feeHeader}>
            {t('exam->>ReviewExam.Fees Payable')}
            <br />
            {t('exam->>ReviewExam.includingGST', { gstPercentage })}
          </Typography>
        ),
        customBodyRenderLite: (dataIndex: number, rowIndex: number) => (
          <Box className={classes.feeCell}>
            <Typography id={`text-examFees-row${rowIndex}`} variant="body2">
              {`S$${dataContent[dataIndex].fee}`}
            </Typography>
          </Box>
        ),
      },
    },
  ];
};

export default ReviewSubjectDataColumn;
